import React from "react";
import styles from "./index.module.scss";
import CheckIcon from "../../assets/images/Stepiconbase.svg";

interface StepperProps {
  currentStep?: number;
}

const Stepper: React.FC<StepperProps> = ({ currentStep = 1 }) => {
  return (
    <div className={styles.stepperContainer}>
      {/* Step 1: Create program */}
      <div
        className={`${styles.step} ${currentStep === 1 ? styles.active : ""
          } ${currentStep > 1 ? styles.completed : ""}`}
      >
        <div className={styles.circle}>
          {currentStep > 1 ? (
            <img src={CheckIcon} alt="completed" className={styles.checkIcon} />
          ) : (
            "1"
          )}
        </div>
        <span
          className={`${styles.label} ${currentStep >= 1 ? styles.activeLabel : ""}`}
        >
          Create program
        </span>
      </div>
      <div
        className={`${styles.line} ${currentStep > 1 ? styles.active_line : styles.inactive_line // Always show the line, just change its style
          }`}
      />
      {/* Step 2: Configure form */}
      <div
        className={`${styles.step} ${currentStep === 2 ? styles.active : ""
          } ${currentStep > 2 ? styles.completed : ""}`}
      >
        <div className={styles.circle}>
          {currentStep > 2 ? (
            <img src={CheckIcon} alt="completed" className={styles.checkIcon} />
          ) : (
            "2"
          )}
        </div>
        <span
          className={`${styles.label} ${currentStep >= 2 ? styles.activeLabel : ""}`}
        >
          Configure form
        </span>
      </div>
      <div
        className={`${styles.line} ${currentStep > 2 ? styles.active_line : styles.inactive_line // Always show the line, just change its style
          }`}
      />
      {/* Step 3: Preview registration form */}
      <div
        className={`${styles.step} ${currentStep === 3 ? styles.active : ""}`}
      >
        <div className={styles.circle}>3</div>
        <span
          className={`${styles.label} ${currentStep === 3 ? styles.activeLabel : ""}`}
        >
          Preview registration form
        </span>
      </div>
    </div>
  );
};

export default Stepper;
// Generated by Copilot
